import { ContentPage } from '../page-factory/content-page';
import { mahaShivratriPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Maha Shivratri - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Experience Maha Shivratri, the Great Night of Shiva, concluding Magh Mela 2026. Join us for this powerful spiritual celebration.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/maha-shivratri',
    },
  ];
};

export default function MahaShivratriPage() {
  return <ContentPage {...mahaShivratriPage} />;
}
